<template>
    <div class="calls-reports">
        <PageTitle v-if="report.title">
          {{ report.title }}
        </PageTitle>
        <w-loader v-if="report.loading"/>
        
        <div v-else v-bind="$attrs" v-on="$listeners">
           <div class="empty-state-holder" v-if="showEmptyState">
            <EmptyState
                :title="{
                    text: 'No activity yet',
                    tag: 'h2'
                }"
                :description="{
                    text: 'Make and receive calls to analyze reports and insights about your business communications.',
                    tag: 'p'
                }"
                :svg="{
                    src: NoActivity,
                    name: 'No activity yet',
                    styles: {
                        maxWidth: '546px'
                    }
                }"
            >
            </EmptyState>
        </div>
        <div v-else>
            <CallReportsFilters :call="report" data-test-id="call-reports-filter"/>
            <w-alert
              v-if="report.alert"
              :message="report.alert.message"
              :level="report.alert.level"
              :closable="report.enable_close_alert"
              @closed="report.alert = null"
              class="mb-6"
            />
            <div v-else-if="(report.items)" id="pdf-export">
                <slot />
            </div>
            <NothingFound
              v-else
              :alert="report.alert"
              :everythingDeleted="false"
              :filters_applied="false"
              :disable_add_new="true"
              data-test-id="call-reports-nothing-found"
            />
            </div>
        </div>
    </div>
</template>

<script>
  import NothingFound from 'console/src/components/elements/NothingFound.vue';
  import PageTitle from 'console/src/components/elements/PageTitle.vue';
  import CallReportsFilters from 'console/src/components/elements/CallReportsFilters.vue';
  import EmptyState from 'console/src/components/elements/empty-state/EmptyState.vue'
  import NoActivity from '../../../../vue-apps-assets/images/empty-state/empty-state.svg'
  import { shouldShowEmptyState } from '../../libs/empty-state'

  export default {
    components: {
      PageTitle,
      NothingFound,
      CallReportsFilters,
      EmptyState,
    },
    data() {
      return {
        NoActivity,
      };
    },
    props: {
        report: {
            type: Object,
            required: true,
        },
    },
     watch: {
      showEmptyState: {
          immediate: true,
          handler(isFullWidth) {
            this.$emit('is-full-width-change', isFullWidth);
          },
      },
    },
    computed: {
        showEmptyState() {
           return shouldShowEmptyState(this.report)
        },
      }
  };
</script>

 <style lang="scss" scoped>
    @import 'vue-apps-assets/styles/scss/vars.scss';

    .empty-state-holder {
        display: flex;
        width: 100%;
        flex: 1 0 auto;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 16px;
        min-height: calc(100vh -  #{$headerHeight + 50px});
        width: 100%;
        flex-direction: column;
    }

</style>
